import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { convertTimeStampToDate } from '../../common/utils/dateUtils';
import { snakeCaseToTitleCase } from '../../common/utils/api_utils';
import * as actions from './redux/actions';
import CustomReactPaginate from '../../common/custom/CustomReactPaginate';
import Swal from 'sweetalert2';
import { REST_API } from 'drapcode-constant';
import showAlert from '../../common/utils/alert';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { description } from '../../common/utils/event_constants';
export class WebhookTable extends Component {
  static propTypes = {
    webhook: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { page: 0 };
  onPageChange = (val) => {
    const { projectId, version } = this.props;
    this.props.actions.loadExternalApis({
      projectId,
      version,
      page: val.selected,
      externalApiType: this.state.activeTab,
    });
    this.setState({ page: val.selected });
  };

  getCollectionTitle = (collectionName) => {
    if (!collectionName) {
      return '-';
    }
    const { collections } = this.props.home;
    const collection = [...collections].find((e) => e.collectionName === collectionName);
    return collection ? collection.collectionTitle : collectionName;
  };

  handleDelete = (uuid) => {
    const { projectId, version, actions } = this.props;
    const preConfirm = () => {
      return actions.deleteWebhook({ uuid, projectId, version });
    };
    showAlert("You won't be able to revert it!", preConfirm, 'Yes, delete it!');
  };

  render() {
    const { version, webhook, projectId, deleteFlag } = this.props;
    const { webhookList, totalWebhookPages } = webhook;
    if (!webhookList || !webhookList.length) {
      return 'No Wehbooks Created Yet';
    }

    return (
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-sm table-word-break connector-list">
          <thead>
            <tr>
              <th>Name</th>
              <th>Collection</th>
              <th>Type</th>
              <th>Created Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {webhookList.map((webhook) => (
              <tr key={webhook.uuid} className="text-left td-align-middle">
                <td>{webhook.name}</td>
                <td>{this.getCollectionTitle(webhook.collectionName)}</td>
                <td>
                  {webhook.type === REST_API ? 'Rest API' : snakeCaseToTitleCase(webhook.type)}
                </td>
                <td>{convertTimeStampToDate(webhook.createdAt)}</td>
                <td className="text-right">
                  <Link
                    to={`/webhook/${version}/v/${projectId}/edit/${webhook.uuid}`}
                    className="btn btn-xs btn-primary"
                    title={`Edit ${webhook.name}`}
                  >
                    <i className="wb webconnect-pencil"></i>
                  </Link>
                  &nbsp;
                  <button
                    className="btn btn-xs btn-theme-delete"
                    style={{ cursor: deleteFlag ? 'pointer' : 'not-allowed' }}
                    onClick={() => (deleteFlag ? this.handleDelete(webhook.uuid) : undefined)}
                    disabled={false}
                    title={`Delete ${webhook.name}`}
                  >
                    <i className="wb webconnect-trash-solid"></i>&nbsp;
                    {deleteFlag ? null : (
                      <TooltipInfo
                        title={description}
                        headerText={`Permission Disabled!`}
                        showHeader={true}
                        showArrow={true}
                      />
                    )}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {totalWebhookPages > 1 && (
          <CustomReactPaginate
            totalPages={totalWebhookPages}
            page={this.state.page}
            pageRangeDisplayed={10}
            marginPagesDisplayed={2}
            onPageChange={this.onPageChange}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    webhook: state.webhook,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WebhookTable);
